import React, { Component } from 'react';
import { getDisplayName } from 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var decorateComponentWithProps = (EmbeddedComponent, props) => {
  var _a;
  return _a = class extends Component {
    render() {
      return /* @__PURE__ */ React.createElement(EmbeddedComponent, __spreadValues(__spreadValues({}, this.props), props));
    }
  }, _a.displayName = `Decorated(${getDisplayName(EmbeddedComponent)})`, _a;
};

export { decorateComponentWithProps as default };
//# sourceMappingURL=decorateComponentWithProps.js.map
